export const DEFAULT_MOVIE_TITLE = "La la land";